import { styled } from '@vw-marketing/us-components';

export const RecallsAppContainer: any = styled.div`
  width: 100%;
`;
interface StyledHelperTextProps {
  withPadding: boolean;
}
export const StyledHelperText: any = styled.div<StyledHelperTextProps>`
  width: 100%;
  ${({ withPadding }: StyledHelperTextProps) =>
    withPadding && `padding-bottom: 50px;`}
`;
